// extracted by mini-css-extract-plugin
module.exports = {"card":"FaqCard_card__hfOfX","card__name":"FaqCard_card__name__2OpGr","card__desc":"FaqCard_card__desc__3iTJm"};